import {collection,getDocs} from 'firebase/firestore';
import {db} from '../Security/firebase-config';
import {pointIdentity} from './improvementPoints';
import {saveImprovementPoint} from './improvementPointsStore';
import {noteClassification} from './noteClassification';

const jobs=new Map();
// Run once per signed-in team session, using a bounded queue. Existing match
// points and their ratings remain untouched; only missing library points are added.
export function backfillImprovementPoints(teamId,maps,existing) {
  if(jobs.has(teamId))return jobs.get(teamId);
  const job=(async()=>{
    const identities=new Set(existing.map(pointIdentity)),queue=[];
    async function include(points) {
      const entries=typeof points==='string'?points.split('\n'):Array.isArray(points)?points:[];
      for(const entry of entries) {
        const raw=typeof entry==='string'?{text:entry}:entry;
        // Imported snapshots already came from the library. Their historical text
        // must not recreate a point after its library entry is edited or moved.
        if(raw?.sourceType==='improvement_note' && raw.sourceId)continue;
        const c=noteClassification(raw),map=c.scope==='map'?maps.find(map=>String(map.name || map.id).toLowerCase()===String(c.mapName || c.mapId).toLowerCase()):null;
        const point=map?{...raw,...c,mapId:map.id,mapName:map.name || map.id}:raw;
        if(!point?.text?.trim() || identities.has(pointIdentity(point)))continue;
        identities.add(pointIdentity(point));
        try{await saveImprovementPoint(teamId,{...point,notificationMigration:true},existing);}catch(error){
          if(!/already exists/i.test(error.message)){identities.delete(pointIdentity(point));throw error;}
        }
      }
    }
    const [plans,preps]=await Promise.all([
      getDocs(collection(db,'teams',teamId,'sessionPlans')),
      getDocs(collection(db,'teams',teamId,'eventPreps')),
    ]);
    for(const plan of plans.docs)await include(plan.data().focusPoints);
    for(const prep of preps.docs) {
      let content;try{content=JSON.parse(prep.data().content || '{}');}catch{continue;}
      const section=content.sections?.focus;
      await include(section?.entries || String(section?.fields?.points?.value || '').split('\n').filter(Boolean).map(text=>({text})));
    }
    const sourceMaps=[...maps,...maps.filter(map=>map.name && map.id!==map.name && !maps.some(other=>other.id===map.name)).map(map=>({...map,id:map.name}))];
    for(const map of sourceMaps)for(const kind of ['matches','videos']) queue.push(async()=>{
      const records=await getDocs(collection(db,'teams',teamId,'maps',map.id,kind));
      for(const record of records.docs) {
        const points=await getDocs(collection(db,'teams',teamId,'maps',map.id,kind,record.id,'focusPoints'));
        await include(points.docs.map(point=>({...point.data()})));
        await include(record.data().focusPoints);
      }
    });
    await Promise.all(Array.from({length:Math.min(4,queue.length)},async()=>{while(queue.length)await queue.shift()();}));
  })();
  jobs.set(teamId,job);job.catch(()=>jobs.delete(teamId));return job;
}
